module.exports = __webpack_public_path__ + "static/media/mysql.9f1817d7.png";